import { render } from "./NotificationSettingCard.vue?vue&type=template&id=5e5dfd22&scoped=true"
import script from "./NotificationSettingCard.vue?vue&type=script&lang=js"
export * from "./NotificationSettingCard.vue?vue&type=script&lang=js"

import "./NotificationSettingCard.vue?vue&type=style&index=0&id=5e5dfd22&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5e5dfd22"

export default script